<template>
  <div class="interviewInfo">
    <new-head title="任务详情" class="pos-top"> </new-head>
    <div class="setUpBox">
      <van-steps
        :active="active"
        active-color="#38f"
        v-if="resumeDetails.resume_status == 2"
      >
        <van-step>发起筛选</van-step>
        <van-step>筛选简历</van-step>
        <van-step>结果</van-step>
      </van-steps>
      <van-steps :active="active" active-color="#38f" v-else>
        <van-step>发起筛选</van-step>
        <van-step>筛选简历</van-step>
        <van-step>待发布</van-step>
        <van-step>面试</van-step>
        <van-step>结果</van-step>
      </van-steps>
    </div>
    <div class="infoTop">
      <h5>{{ resumeDetails.task_name }}</h5>
      <p class="time">{{ `${resumeDetails.start_time}-${resumeDetails.end_time}` }}</p>
      <div class="line3">
        <p v-if="resumeDetails.task_tag == '高管'">{{ resumeDetails.task_tag }}</p>
        <div class="prise">
          <img src="@/assets/image/prise.png" alt="" />
          <span>{{ moneyFormat(resumeDetails.task_bonus) }}</span>
        </div>
      </div>
    </div>
    <div class="nav">
      <div
        class="navItem flex-center"
        v-for="(item, i) in navList"
        :key="i"
        :class="{ navActive: navIdx == i }"
        @click="navIdx = i"
      >
        {{ item }}
      </div>
    </div>
    <div v-show="navIdx == 0">
      <details-com :resumeDetails="resumeDetails"></details-com>
    </div>
    <div v-show="navIdx == 1">
      <screening-results :listData="resumeList"></screening-results>
    </div>
    <div v-show="navIdx == 2">
      <screening-results :listData="interviewList"></screening-results>
    </div>

    <!-- -->
    <div class="bottomBtn pos-bottom">
      <div class="flex-center" @click="callPhone()" v-if="resumeDetails.is_create != 1">
        电话沟通
      </div>

      <div class="fillIn flex-center" v-if="resumeDetails.is_permission == 1">
        <template v-if="active == 1">
          <span class="fontCenter disable" v-if="resumeDetails.is_write == 1">
            已填写</span
          >
          <span
            v-else
            class="fontCenter"
            @click="$router.push('/addAssessment?type=1&task_id=' + task_id)"
          >
            填写简历筛选评估表
          </span>
        </template>
        <template v-if="active == 2">
          <span class="fontCenter"  @click="$router.push('/InitiateInterview?task_id=' + task_id)"> 
          发起面试
          </span>
        </template>
        
        <template v-if="active == 3">
          <span
            class="fontCenter"
            v-if="resumeDetails.is_write == 0"
            @click="$router.push('/addAssessment?type=2&task_id=' + task_id)"
          >
            填写面试评估表
          </span>
          <span class="fontCenter disable" v-else> 已填写</span>
        </template>

        <template v-if="active == 4">
          <span v-if="resumeResult == '推荐录用'">{{ resumeResult }}</span>
          <span v-else class="disable">{{ resumeResult }}</span>
        </template>
      </div>

      <div class="fillIn flex-center" v-if="resumeDetails.is_permission == 2">
        <span class="fontCenter disable"> 无权限</span>
      </div>

    </div>

    <!-- <div class="bottomBtn pos-bottom" v-if="resumeDetails.is_create == 1 && active == 2">
      <div class="fillIn flex-center">
        <template>
          <span
            class="fontCenter"
            v-if="resumeDetails.is_permission == 1"
            @click="$router.push('/InitiateInterview?task_id=' + task_id)"
          >
            发起面试
          </span>
          <span class="fontCenter disable" v-else> 无权限</span>
        </template>
      </div>
    </div> -->
  </div>
</template>

<script>
import detailsCom from "./components/detailsCom.vue";
import screeningResults from "./components/screeningResults.vue";
import { resumeTaskDetailsApi } from "@/api/api/resume";
export default {
  components: {
    detailsCom,
    screeningResults,
  },
  data() {
    return {
      active: 0, //1简历筛选2待发布面试3发布面试4已完成
      navIdx: 0,
      navList: ["任务详情", "筛选结果"],
      resumeDetails: "",
      resumeList: {
        type: "1",
        list: [],
        text: "",
      }, //筛选结果
      interviewList: {
        type: "2",
        list: [],
        text: "",
      }, //面试结果
      task_id: null,
      resumeResult: "",
    };
  },
  watch: {},
  created() {
    let id = this.$route.query.task_id;
    this.task_id = id;
    this.getData(id);
  },
  methods: {
    async getData(id) {
      let res = await resumeTaskDetailsApi(id);
      let data = res.data.data;
      this.resumeResult = data.resumeResult;
      this.resumeDetails = data.resumeDetails;
      console.log({ ...this.resumeDetails });
      this.active = data.resumeDetails.status;
      if (this.active >= 3 && data.resumeDetails.resume_status != 2) {
        this.navList = ["任务详情", "筛选结果", "面试结果"];
      }

      this.resumeList.list = data.resumeList.interviewList;
      this.resumeList.text = data.resumeList.result_text;

      this.interviewList.list = data.interviewList.interviewList;
      this.interviewList.text = data.interviewList.result_text;

      console.log(this.resumeList);
    },
    callPhone() {
      window.location.href = "tel://" + this.resumeDetails.crate_mobile + "";
    },
  },
};
</script>

<style lang="scss" scoped>
.interviewInfo {
  padding: 44px 0;
}
.infoTop {
  border-bottom: 1px solid #d8d8d8;
  margin: 15px;
  padding-bottom: 10px;

  h5 {
    font-size: 16px;
  }

  .time {
    font-size: 14px;
    color: #979797;
    margin: 8px 0;
  }

  .line3 {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      background-color: #ff7a15;
      color: #fff;
      padding: 2px 5px;
      border-radius: 4px;
    }

    .prise {
      display: flex;
      align-items: center;

      img {
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
    }
  }
}

.nav {
  display: flex;

  .navItem {
    width: 69px;
    height: 22px;
    text-align: center;
    background: #e9f2ff;
    border-radius: 3px;
    font-size: 13px;
    color: #0286ff;
    margin-left: 11px;
  }

  .navActive {
    background-color: #0286ff;
    color: #fff;
  }
}

.bottomBtn {
  width: 100vw;
  height: 47px;
  display: flex;

  > div {
    flex: 1;
    height: 100%;
    background: #e9f2ff;
    border: 1px solid #0286ff;
    font-size: 12px;
    color: #0286ff;
  }

  .fillIn {
    color: #fff;
    border: none;

    span {
      display: block;
      width: 100%;
      height: 100%;
      background-color: #0286ff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .disable {
      background-color: #ccc;
    }
  }
}
</style>
